"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = (function (reducer) { return reducer.includes('/'); });
//# sourceMappingURL=isListener.js.map